import React from "react";
import Embed from "react-runkit";

class Playground extends React.Component {
  render() {
    return (
      <Embed
        source={`
        const mulika = require("mulika");

        const registered = true;
        // 1. Type check...
        mulika.typeCheck({ type: "boolean", value: registered });
        // 2. All tests...
        const add = (a, b) => {
          return a + b;
       }
        mulika.expect("sum to be 10", add(1, 9), 10);
        `}
      />
    );
  }
}
export default Playground;
